'use client';
import { Input } from '@/components/ui/input';
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Loader2, Send } from 'lucide-react';
import { SubscribeResponse } from '@/types/subscribe';
import { postSubscribe } from '@/server/actions/postSubscribeAction';

interface NewsletterProps {
  isMobile?: boolean;
}

const Newsletter = ({ isMobile = false }: NewsletterProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
  });

  const isFormValid = formData.email.trim() !== '';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const finalFormData = {
        email: formData.email,
      };

      const result: SubscribeResponse = await postSubscribe(finalFormData);

      if (result.success) {
        alert('✅ You’ve been subscribed successfully!');

        // Reset form
        setFormData({
          email: '',
        });
      }
    } catch (error) {
      console.error('❌ Error subscribing:', error);
      alert('❌ Failed to subscribe.');
    } finally {
      setIsSubmitting(false);
    }
  };

  function toLowercase(input: string): string {
    return input.toLowerCase();
  }

  return (
    <div
      className={`text-sm font-normal ${
        isMobile ? 'mt-8 mb-8 md:mt-16 lg:hidden' : 'my-6 hidden md:mt-16 lg:block' }`}>
      <h3 className="text-muted-foreground mb-7 font-mono text-sm font-bold uppercase">
        {isMobile ? 'Get in touch' : 'Get in touch'}
      </h3>

      <form onSubmit={handleSubmit} className="mb-2">
        <div
          className="group focus-within:ring-ring/50 focus-visible:border-primary size-12 w-full items-center
            rounded-sm shadow-none focus-within:ring-3 xl:flex">
          <div
            className="group dark:bg-input/30 dark:focus-within:border-primary/30 focus-within:border-primary/40 flex
              size-12 w-full items-center gap-1 rounded-sm border p-1 pb-1.5 shadow-none transition-colors">
            <Input
              type="email"
              id="email"
              value={formData.email}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  email: toLowercase(e.target.value),
                }))
              }
              required
              className="text-foreground placeholder:text-muted-foreground mx-0 h-full w-full translate-px rounded-sm
                border-0 bg-transparent text-sm font-normal shadow-none placeholder:text-sm focus:ring-0
                focus:outline-none focus-visible:ring-0 dark:bg-transparent dark:focus:ring-0
                dark:focus-visible:ring-0"
              placeholder="Your email address"
            />
            <Button
              variant={'default'}
              type="submit"
              disabled={isSubmitting || !isFormValid}
              className="hover:bg-opacity-90 mt-0.5 rounded-sm text-sm font-medium transition">
              {isSubmitting ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" /> Submitting...
                </>
              ) : (
                <>
                  <Send className="mr-2 h-4 w-4" /> Subscribe
                </>
              )}
            </Button>
          </div>
        </div>
      </form>
      <p
        className={`text-xs font-semibold ${isMobile ? 'text-body w-full' : 'text-subtitle max-w-max'}`}>
        By submitting your email, you&apos;ll be the first to know about upcoming updates from
        Ucon Fixings. You can unsubscribe at any time.
      </p>
    </div>
  );
};

export default Newsletter;
